import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import type { ClosePortalFn } from 'modules/core/components/Portal/useCloseProxy'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'
import { apiClient } from 'modules/core/lib/mobx-rest'

import type Survey from 'modules/surveys/store/models/v2/Survey'

interface DeleteModalProps {
  survey: Survey
  supervisorId: number
  onClose: () => void
}

const DeleteAuthorAsEditorModal = ({ survey, supervisorId, onClose }: DeleteModalProps) => {
  const api = apiClient()

  const { running, performAction: onDelete } = useAsyncAction(
    async (closePortal: ClosePortalFn) => {
      await api.del(`/surveys/v2/surveys/${survey.attributes.id}/supervisors`, {
        access_id: supervisorId,
        form_id: survey.attributes.id,
      })
      survey.fetch()
      closePortal()
    },
    {
      successMessage: i18n.t('surveys.form.managers.delete_modal.supervisor_deleted'),
    }
  )

  return (
    <Modal
      aria-label="Remove author as editor"
      illustration="alert"
      title={i18n.t('surveys.form.managers.delete_modal.title')}
      description={i18n.t('surveys.form.managers.delete_modal.description')}
      onClose={onClose}
      onSubmit={onDelete}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={running} submit>
            {i18n.t('common.continue')}
          </Button>
        </>
      }
    />
  )
}

export default observer(DeleteAuthorAsEditorModal)
